// Only enable debug logs if explicitly set via LOG_LEVEL=debug
// In Vite, use import.meta.env instead of process.env
export const debugEnabled: boolean =
  (import.meta.env.VITE_LOG_LEVEL || '').toLowerCase() === 'debug';

export const log = (...args: any[]): void => {
  if (debugEnabled) console.log(...args);
};

export const warn = (...args: any[]): void => {
  // Warnings always show - they're important
  console.warn(...args);
};

export const error = (...args: any[]): void => {
  // Always surface errors
  console.error(...args);
};


